import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {EventDto} from "../../../../models/event/event-dto";
import {
  EventAnalysisCollectionDto
} from "../../time-performance-analysis-module/http/models/event-analysis-collection-dto";
import {Observable} from "rxjs";
import {ServerEndpoints} from "../../../../server.endpoints";

@Injectable({
  providedIn: 'root'
})
export class AnalyticsHttpService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, @Inject('BASE_HEADERS') baseHeaders: HttpHeaders) {
  }

  fetchEventData(startTime: string, endTime: string) {
    return this.http.get<EventAnalysisCollectionDto[]>(this.baseUrl + ServerEndpoints.Analysis_EventAnalysis_FetchEventData + "?startTime=" + startTime + "&endTime=" + endTime);
  }

  searchEventsByName(name: string): Observable<EventDto[]> {
    return this.http.get<EventDto[]>(this.baseUrl + ServerEndpoints.Analysis_EventAnalysis_GetEventsLike + "?name=" + name);
  }
}
